import actions from './actions.js'
import mutations from './mutations'

export const DEFAULT_INDEX_OBJECT = {
  username: null,
  token: null,
  loading: false,
  refreshToken: null,
  expires: null,
  refreshInterval: null,
  loggedIn: false,
  allPermissions: null,
}

function state() {
  return {
    ...DEFAULT_INDEX_OBJECT,
  }
}

const getters = {
  allPermissions: state => (state.allPermissions ? state.allPermissions : []),
}

const module = {
  state,
  getters,
  mutations,
  actions,
}

export default module



// WEBPACK FOOTER //
// ./src/app/store/modules/idmAuth/index.js